<template>
  <div style="flex:1;">
    <v-chart :forceFit="true" :height="height" :data="chartData" :scale="scale" :padding="[20,10,40,10]">
      <v-tooltip :showTitle="false" dataKey="item*percent" />
      <v-axis />
      <v-legend dataKey="item" />
      <v-pie position="percent" color="item" :vStyle="pieStyle" :label="labelConfig" />
      <v-coord type="theta" :radius="0.75" :innerRadius="0.6" />
    </v-chart>
  </div>
</template>

<script>
const DataSet = require('@antv/data-set');


const scale = [{
  dataKey: 'percent',
  min: 0,
  formatter: '.0%',
}];

const createChartData = (originalData)=>{

  if(!originalData) return []

  const sourceData = []
  
  for(let key in originalData){
      if(key !== 'endDate'){

        sourceData.push({item:key,value:Number(originalData[key])})
      }
  }

const dv = new DataSet.View().source(sourceData);
  dv.transform({
    type: 'percent',
    field: 'value',
    dimension: 'item',
    as: 'percent'
  });
  const data = dv.rows;
  return data
}


export default {
  props:['originalData'],
  data() {
    return {
      scale,
      height: 390,
      pieStyle: {
        stroke: "#fff",
        lineWidth: 1
      },
      labelConfig: ['percent', {
        formatter: (val, item) => {
          return item.point.item + ': ' + val;
        }
      }],
    };
  },
  computed: {
    chartData(){
      return createChartData(this.originalData)
    }
  }
};
</script>